'use client';
import { ReactNode } from 'react';
import { Dialog as MuiDialog, DialogProps } from '@mui/material';

export function Dialog({ children, ...otherProps }: BaseDialogProps) {
  return <MuiDialog {...otherProps}>{children}</MuiDialog>;
}

interface BaseDialogProps extends Omit<DialogProps, 'children'> {
  children: ReactNode;
}
